import React, { useState } from "react";
import { TextField, IconButton, Box } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import SiTextField from "../../../../core/si-textfield";

const InputWithAction = ({
  updateStateFun,
  stateValue,
  placeholder = "Enter Input",
}) => {
  const [inputValue, setInputValue] = useState("");
  const [isEditing, setIsEditing] = useState(false);

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
    setIsEditing(true);
  };

  const handleAdd = () => {
    if (inputValue.trim()) {
      updateStateFun([...stateValue, inputValue.trim()]);
      setInputValue("");
      setIsEditing(false);
    }
  };

  const handleClear = () => {
    setInputValue("");
    setIsEditing(false);
  };

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <SiTextField
        placeholder={placeholder}
        value={inputValue}
        onChange={handleInputChange}
      />

      {isEditing && (
        <>
          <IconButton color="success" onClick={handleAdd}>
            <CheckIcon />
          </IconButton>
          <IconButton color="error" onClick={handleClear}>
            <CloseIcon />
          </IconButton>
        </>
      )}
    </Box>
  );
};

export default InputWithAction;
